import React, { createContext, useContext } from 'react';
import { TOContext } from './TContext';

const tipInfoSettings = {
  kitchen: {
    enabled: true,
    visibleForDriver: true,
  },
  driver: {
    enabled: true,
    visibleForDriver: true,
  },
};

// This is where your logic lives (i.e., inner hook executed inside context)
const useProvideTipInfoSettings = (business) => {
  return business.settings?.tipInfoSettings || tipInfoSettings;
};
const TipInfoSettingsContext = createContext(undefined);
// Provider that runs the hook internally and exposes its value
export const TipInfoSettingsProvider = ({ children }) => {
  const { business } = useContext(TOContext);
  const tipInfoSettings = useProvideTipInfoSettings(business);

  return (
    <TipInfoSettingsContext.Provider value={tipInfoSettings}>
      {children}
    </TipInfoSettingsContext.Provider>
  );
};

// Consumer hook
export const useTipInfoSettingsContext = () => {
  const context = useContext(TipInfoSettingsContext);
  if (!context) {
    throw new Error('useTipInfoSettingsContext must be used within TipInfoSettingsProvider');
  }
  return context;
};
